<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>
<style>
@import "./assets/font/font.css";

body {
    font-family: "微软雅黑";
    background-color: var(--bg-color-1);
    margin: 0;
    color: #ffffff;
    width: 1920px;
    margin: 0 auto;
    -webkit-text-size-adjust: none !important;
    margin-bottom: 20px;
    overflow-x: hidden;
}

header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 999;
}

.content-body {
    margin-top: 100px;
}

.banner {
    /*border-bottom: 1px solid #333333;*/
    text-align: center;
    height: 44px;
    background-color: var(--bg-color-1);
    padding-top: 44px;
}

.back-icon {
    width: 22px;
    height: 22px;
    margin: 11px 15px;
    float: left;
}

.banner-title {
    font-size: 19px;
    text-align: center;
    margin: 13px 0;
    line-height: 19px;
    color: var(--text-color-1);
    opacity: 0.9;
}

.van-dialog {
    background: var(--bg-color-2);
}

.van-button--default {
    background: var(--bg-color-2);
}

.van-overlay {
    background-color: rgba(0, 0, 0, 0.5);
}

[class*=van-hairline]::after {
    border: 2px solid var(--bg-color-1);
}

.van-button {
    font-size: 15px;
}

.van-dialog__header {
    font-size: 18px;
}

.van-dialog__message {
    font-size: 15px;
    line-height: 1.5;
    color: var(--text-color-1);
    text-align: left;
}

.van-toast {
    background-color: #404040;
    font-size: 12px;
}

.color-bg-ls {
    color: #00AC50;
}

.color-bg-ls {
    background-color: #00AC50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue